const CLEAR_BUTTON = {

  id: "clear",
  type: "clearbutton",
  props: {
    className: "clearbutton"
  }

}

const SUBMIT_BUTTON = {

  id: "submit",
  type: "submitbutton",
  props: {
    className: "submitbutton"
  }

}

const COL_CLEAR_SUBMIT_BUTTON = {

  id: "col_clear_submit_button",
  type: "col",
  props: {
    className: "d-flex flex-row gap-2"
  },
  children: [
    SUBMIT_BUTTON,
    CLEAR_BUTTON,
  ]

}

export { CLEAR_BUTTON, SUBMIT_BUTTON, COL_CLEAR_SUBMIT_BUTTON };
